import { LoginRequired } from '@/components/LoginRequired';
import { SplashScreen } from '@/components/SplashScreen';
import APITestProof from '@/routes/APITestProof';
import AccountList from '@/routes/AccountList';
import Login from '@/routes/Login';
import NotFound from '@/routes/NotFound';
import ReceiptView from '@/routes/ReceiptView';
import Receipts from '@/routes/Receipts';
import { UploadSuccess } from '@/routes/UploadSuccess';
import { useAuth } from '@auth';
import { Redirect, Route, Switch, useLocation } from 'wouter';
import MainLayout from './MainLayout';
import { AddReceiptProvider } from './providers/AddReceiptContext';
import AccountDetails from './routes/AccountDetails';
import { ViewReceiptImage } from './routes/ViewReceiptImage';
import { LazyLabs } from './routes/labs/LazyLabs';
import { MainErrorBoundary } from '@/lib/MainErrorBoundary';
import React from 'react';
import { useSentryBrowserTracing } from './lib/sentry';
import AnimatedRoutes from './components/AnimatedRoutes';

const AdminRoutes = React.lazy(() => import('./routes/admin/AdminRoutes'));

function App() {
  const { isLoading, user } = useAuth();
  const [location] = useLocation();
  useSentryBrowserTracing(location);

  return (
    <MainLayout>
      <Switch>
        <Route path="/login" component={Login} />

        {!isLoading && !user ? (
          <Route>
            <Redirect to={`/login?returnURI=${encodeURIComponent(location)}`} replace={false} />
          </Route>
        ) : (
          <MainErrorBoundary>
            <Route path="/" nest>
              <LoginRequired fallback={<SplashScreen />}>
                <Route path="/labs" nest>
                  <LazyLabs />
                </Route>

                <AddReceiptProvider>
                  <AnimatedRoutes>
                    <Route path="/" component={AccountList} />
                    <Route path="/account/:accountId" component={AccountDetails} />
                    <Route path="/upload-success/" component={UploadSuccess} />
                    <Route path="/receipts" component={Receipts} />
                    <Route path="/receipts/:receiptId" component={ReceiptView} />
                    <Route path="/receipts/:receiptId/view-image" component={ViewReceiptImage} />
                  </AnimatedRoutes>
                </AddReceiptProvider>
                <Route path="/api-test-proof" component={APITestProof} />
                <Route path="/admin" nest>
                  <AdminRoutes />
                </Route>
              </LoginRequired>
            </Route>
          </MainErrorBoundary>
        )}
        <Route component={NotFound} />
      </Switch>
    </MainLayout>
  );
}

export default App;
